import Api from "../services/Api";
/*import {stationData } from "../store";
import { get } from 'svelte/store';*/
import { stationStore } from "../store";
const { trackList } = stationStore;
export const glasbeniSos = async (radioStation) => {
    const response = await Api.get(`/preslikave/sos?client_id=4bfbad21ff0272c130c7d16f67b5ceca&station=${radioStation}&_=1651812950285`, {});
    try {
        if (response.response) {
            if (radioStation === 'ars') {
                response.response.map(function (element) {
                    element.performer_name = element.artist_name;
                    element.artist_name = element.author;
                    let tempTitleName = element.title_name;
                    let tempArtistName = element.artist_name;
                    element.artist_name = tempTitleName;
                    element.title_name = tempArtistName;
                    // element.artist_name = element.author
                });
            }
            trackList.set(response.response);
        }
    }
    catch (error) {
        console.log('error', error);
    }
};
